import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { makeStyles } from 'tss-react/mui';

const PageNotFound: React.FC = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack className={classes.pageNotFound} direction={'row'} alignItems={'center'} justifyContent={'center'}>
      <Stack className={classes.inner} gap={2} alignItems={'center'}>
        <Typography className={classes.eyebrow}>{t('pageNotFoundEyebrow')}</Typography>
        <Typography className={classes.title}>{t('pageNotFoundHeadline')}</Typography>
        <Typography className={classes.paragraph}>{t('pageNotFoundDescription')}</Typography>
        <Stack className={classes.actions} direction={'row'} justifyContent={'center'} alignItems={'center'} gap={1.5}>
          <Button className={classes.outlineButton} disableElevation={true} disableRipple={true} onClick={() => navigate(-1)}>
            {t('pageNotFoundBack')}
          </Button>
          <Button className={classes.gradientButton} disableElevation={true} disableRipple={true} onClick={() => navigate('/')}>
            {t('pageNotFoundHome')}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  pageNotFound: {
    height: 'calc(100dvh - 60px - 32px)',
    maxHeight: '900px',
  },
  inner: {
    maxWidth: '520px',
    textAlign: 'center',
  },
  eyebrow: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 700,
    letterSpacing: '0.12em',
    color: theme.palette.primary.main,
  },
  title: {
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 500,
    letterSpacing: '-0.2px',
    textAlign: 'center',
  },
  paragraph: {
    fontSize: theme.typography.pxToRem(16),
    color: '#555',
    textAlign: 'center',
  },
  actions: {
    marginTop: '8px',
  },
  outlineButton: {
    height: '44px',
    padding: '0 20px',
    border: '1px solid #E3E3E8',
    borderRadius: '8px',
    background: '#FFF',
    color: '#555',
    fontSize: theme.typography.pxToRem(15),
    textTransform: 'none',
    '&:hover': {
      background: '#FFF',
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  },
  gradientButton: {
    height: '44px',
    padding: '0 24px',
    border: 'none',
    borderRadius: '8px',
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    color: '#FFF',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 700,
    textTransform: 'none',
    '&:hover': {
      background: `linear-gradient(to right, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
    },
  },
}));

export default PageNotFound;
